import { render, staticRenderFns } from "./vipLog.vue?vue&type=template&id=182b50ed&"
import script from "./vipLog.vue?vue&type=script&lang=js&"
export * from "./vipLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports